<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'PortForwardingList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Port Forwarding
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Port Forwarding</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="PortForwarding">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <multiselect
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">From Port</label>
                    <!-- <input type="text" id="port_from" name="port_from" v-model="value.port_from" v-validate="'required|numeric'"
                      class="form-control port_from" placeholder="Src Port"> -->

                    <input
                      type="text"
                      id="port_from"
                      name="port_from"
                      v-validate="'required|numeric'"
                      v-bind:class="{ 'has-error': errors.has('port_from') }"
                      v-model="value.port_from"
                      class="form-control port_from"
                      placeholder="Src Port"
                    />
                    <div class="help text-danger" v-show="errors.has('port_from')">
                      {{ `The port field may only contain numeric characters` }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">To Port</label>
                    <input
                      type="text"
                      id="port_to"
                      name="port_to"
                      v-validate="'required|numeric'"
                      v-bind:class="{ 'has-error': errors.has('port_to') }"
                      v-model="value.port_to"
                      class="form-control port_to"
                      placeholder="Dest. Port"
                    />
                    <div class="help text-danger" v-show="errors.has('port_to')">
                      {{
                        `The destination port field may only contain numeric characters`
                      }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Protocol</label>
                    <!-- <input type="text" id="tcp_udp" name="tcp_udp" v-model="value.tcp_udp" class="form-control tcp_udp" v-validate="'required'"
                      placeholder="Protocol"> -->

                    <!-- <multiselect
                      v-model="value.tcp_udp"
                      :options="pre.protocol"
                      placeholder="Select Protocol"
                      :searchable="true"
                      :multiple="false"
                      id="tcp_udp"
                      v-bind:class="{ 'has-error': errors.has('tcp_udp') }"
                      v-validate="'required'"
                      name="tcp_udp"
                    >
                    </multiselect> -->
                    <div class="d-flex">
                      <label
                        class="radio mr-3"
                        v-for="(tcp_udp, index) in ['TCP', 'UDP', 'Both']"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :value="tcp_udp"
                          v-model="value.tcp_udp"
                          name="tcp_udp"
                          id="tcp_udp"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>{{ tcp_udp.toUpperCase() }}
                      </label>
                    </div>
                    <div class="help text-danger" v-show="errors.has('tcp_udp')">
                      {{ errors.first("tcp_udp") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Source IP Address</label>
                    <input
                      type="text"
                      id="src_ip_address"
                      name="src_ip_address"
                      v-validate.lazy="'ip_CIDR'"
                      v-bind:class="{
                        'has-error': errors.has('src_ip_address'),
                      }"
                      v-model="value.src_ip_address"
                      class="form-control src_ip_address"
                      placeholder="Example : 0.0.0.0/0"
                    />
                    <div class="help text-danger" v-show="errors.has('src_ip_address')">
                      {{ errors.first("src_ip_address") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Host IP Address</label>
                    <input
                      type="text"
                      id="host_ip_address"
                      name="host_ip_address"
                      v-model="value.host_ip_address"
                      v-bind:class="{
                        'has-error': invalidIPAddress,
                      }"
                      class="form-control host_ip_address"
                      placeholder="Host IP"
                    />
                    <div class="help text-danger" v-if="invalidIPAddress">
                      Please enter a valid IP address.
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Description</label>
                    <input
                      id="description"
                      name="description"
                      v-model="value.description"
                      v-validate="'required'"
                      class="form-control description"
                      placeholder="Description"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "PortForwardingForm",
  metaInfo: {
    title: "Port Forwarding | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      host_ip_address: "",
    },
    invalidIPAddress: false,
    pre: {
      protocol: ["TCP", "UDP", "Both"],
      audraName: [],
    },
  }),
  watch: {
    "value.host_ip_address": function (newVal) {
      this.validateIPAddress();
    },
  },
  methods: {
    validateIPAddress() {
      const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

      if (!ipRegex.test(this.value.host_ip_address)) {
        this.invalidIPAddress = true;
      } else {
        this.invalidIPAddress = false;
      }
    },
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/port_forwarding";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/port_forwarding/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "PortForwardingList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/port_forwarding/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }
      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });
      this.setCustomValidation();
      this.is_loading = false;
    },
    setCustomValidation: function () {
      this.$validator.extend("ip_CIDR", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24",
        validate: (value) => {
          return this.validateIpCidr(value) ? 1 : 0;
        },
      });
    },
    validateIpCidr(value) {
      if (!value) return 1;
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
